const LogoNectar = ({ width = "64", height = "54" }) => {
  return (
    <img
      src={process.env.PUBLIC_URL + "/Logo-Nectar-H.webp"}
      alt="Logo Nectar y Raíz"
      width={width}
      height={height}
      style={{ objectFit: "contain" }}
    />
  );
};

export default LogoNectar;
